// extracted by mini-css-extract-plugin
export default {"toggleList":"toggleList__koUkH","item":"item__30DuY","narrow":"narrow__bhfBd","pill":"pill__x2f32","iconOnly":"iconOnly__KiXu4","iconOnlyRound":"iconOnlyRound__2ABXd"};